var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStufiGesloten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.03 249.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #37474f;\n      }\n\n      .cls-3 {\n        fill: #455a64;\n      }\n\n      .cls-4 {\n        fill: #a6a6a6;\n      }\n\n      .cls-5 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-6 {\n        fill: #767676;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        fill: #ffc727;\n      }\n\n      .cls-9, .cls-10 {\n        opacity: .1;\n      }\n\n      .cls-11 {\n        fill: none;\n      }\n\n      .cls-12 {\n        fill: #7329e8;\n      }\n\n      .cls-13 {\n        fill: #374246;\n      }\n\n      .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-14 {\n        fill: #263238;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.97,
    y: 62.46,
    width: 91.38,
    height: 50.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 191.19,
    y1: 44.71,
    x2: 148.28,
    y2: 35.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m190.39,249.27h34.64s-1.14-4.88-3.44-5.23c-1.41-.12-2.76.64-3.37,1.93,0,0,.11-6.82-4.18-7.97s-7.89,4.86-7.89,4.86c0,0-2.69-3.44-6.36-3.22-3.67.22-4.59,5.89-4.59,5.89,0,0-3.34-1.97-4.81,3.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-4--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.64,249.27h37.53s-.09-5.59-3.78-7.1c-2.06-.88-4.46-.3-5.89,1.42,0,0-1.5-10.29-8.39-10.29s-10.14,8.87-10.14,8.87c-1.19-1.73-3.3-2.58-5.36-2.18-3.81.53-3.97,9.28-3.97,9.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3.68,
    width: 200.58,
    height: 249.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 172.03,
    y: 128.49,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 179.66,
    y: 121.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.39,
    y: 121.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.18,
    y: 51.1,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 143.82,
    y: 58.39,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 14.84,
    y: 121.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 14.84,
    y: 209.42,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 7.21,
    y: 202.12,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 123.85,
    y: 224.4,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 116.2,
    y: 231.69,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 14.86,
    y: 25.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 186.51,
    y: 11.14,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0,
    y: 137.99,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0,
    y: 41.04,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0,
    y: 243.43,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0,
    y: 243.43,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.57,
    y: 59.44,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 27.59,
    y: 62.46,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "58.64 62.46 58.64 68.58 27.59 99.63 27.59 84.91 50.06 62.46 58.64 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "58.64 94.54 58.64 109.25 54.69 113.21 39.98 113.21 58.64 94.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "58.64 88.09 58.64 91.2 36.63 113.21 33.53 113.21 58.64 88.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "46.93 62.46 27.59 81.8 27.59 75.7 40.84 62.46 46.93 62.46"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.59,
    y: 77,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.57,
    y: 152.53,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 27.59,
    y: 155.55,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "58.64 155.55 58.64 161.67 27.59 192.72 27.59 178 50.06 155.55 58.64 155.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "58.64 187.63 58.64 202.34 54.69 206.29 39.98 206.29 58.64 187.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "58.64 181.18 58.64 184.28 36.63 206.29 33.53 206.29 58.64 181.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "46.93 155.55 27.59 174.88 27.59 168.79 40.84 155.55 46.93 155.55"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.59,
    y: 170.09,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.43,
    y: 152.53,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 88.45,
    y: 155.55,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "119.5 155.55 119.5 161.67 88.45 192.72 88.45 178 110.92 155.55 119.5 155.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "119.5 187.63 119.5 202.34 115.55 206.29 100.84 206.29 119.5 187.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "119.5 181.18 119.5 184.28 97.49 206.29 94.39 206.29 119.5 181.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "107.79 155.55 88.45 174.88 88.45 168.79 101.7 155.55 107.79 155.55"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.45,
    y: 170.09,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.43,
    y: 59.44,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 88.45,
    y: 62.46,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.5 62.46 119.5 68.58 88.45 99.63 88.45 84.91 110.9 62.46 119.5 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.5 94.54 119.5 109.25 115.53 113.21 100.83 113.21 119.5 94.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.5 88.09 119.5 91.2 97.48 113.21 94.38 113.21 119.5 88.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "107.78 62.46 88.45 81.8 88.45 75.7 101.7 62.46 107.78 62.46"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.43,
    y: 59.44,
    width: 97.94,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 88.97,
    y: 62.46,
    width: 91.38,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "171.75 62.46 149.3 84.91 149.3 84.91 137.54 96.67 137.54 96.67 136.27 97.94 131.55 102.66 109.1 125.11 109.1 139.83 113.82 135.11 126.07 122.86 140.15 108.78 144.87 104.06 149.3 99.63 157.12 91.81 180.35 68.58 180.35 62.46 171.75 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "161.69 113.21 149.92 124.96 149.93 124.96 138.45 136.43 138.46 136.43 126.2 148.68 126.2 148.68 121.48 153.41 136.18 153.41 140.15 149.45 140.15 148.68 140.9 148.68 144.87 144.73 144.87 136.43 153.15 136.43 157.12 132.48 157.12 124.96 164.63 124.96 168.6 121.01 168.6 113.21 176.38 113.21 180.35 109.25 180.35 94.54 161.68 113.21 161.69 113.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "154.96 113.49 143.48 124.96 143.48 124.96 132.01 136.43 132.01 136.43 119.76 148.68 119.76 148.68 115.04 153.41 118.13 153.41 140.15 131.4 140.15 131.39 144.87 126.67 144.87 126.67 157.12 114.42 157.12 114.42 168.6 102.95 168.6 102.94 180.35 91.2 180.35 88.09 157.12 111.32 154.96 113.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "128.44 102.66 133.16 97.94 133.16 97.94 145.41 85.69 145.41 85.69 149.3 81.8 168.64 62.46 162.55 62.46 150.79 74.22 149.3 75.7 137.54 87.46 137.54 87.46 127.07 97.94 127.07 97.94 122.34 102.66 122.34 102.66 109.1 115.91 109.1 122 128.44 102.66 128.44 102.66"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m66.87,249.27s-1.58-7.34-4.74-8.53-5.09,2.18-5.09,2.18c0,0-.74-7.06-5.25-9.17-4.5-2.11-7.85,2.21-7.85,2.21,0,0-3.44-8.96-9.59-8.96s-9.24,13.1-9.24,13.1c0,0-3.63-3.9-7.34-1.7-3.71,2.2-3.72,10.86-3.72,10.86h52.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m90.56,249.27h-29.26s.06-4.35,2.94-5.51c1.6-.7,3.47-.25,4.58,1.1,0,0,1.17-8.01,6.54-8.01s7.93,6.91,7.93,6.91c.93-1.36,2.58-2.03,4.2-1.7,2.95.39,3.07,7.21,3.07,7.21Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 145.8,
    y: 152.53,
    width: 41.38,
    height: 96.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.45,
    y: 77,
    width: 92.58,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 175.96,
    y: 213.68,
    width: 12.22,
    height: 5.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.72,
    y: 152.53,
    width: 41.38,
    height: 96.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 151.88,
    y: 158.84,
    width: 29.07,
    height: 79.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "180.95 223.29 180.95 237.05 179.41 238.59 165.64 238.59 180.95 223.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "180.95 158.84 180.95 163.53 151.88 192.61 151.88 178.85 171.88 158.84 180.95 158.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "180.95 169.21 180.95 172.11 151.88 201.18 151.88 198.28 180.95 169.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "180.95 201.15 180.95 204.05 151.88 233.12 151.88 230.22 180.95 201.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "159.94 158.84 151.88 166.91 151.88 161.21 154.24 158.84 159.94 158.84"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 182.79,
    y: 208.63,
    width: 2.55,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.88,
    y: 205.97,
    width: 29.07,
    height: 2.66
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.48,19.63c-1.58,0-2.52.58-2.47,1.39.07.95,1.27,1.48,3.46,1.87,4.85.88,6.84,1.95,6.84,4.82-.01,3.34-3.24,5.16-7.94,5.14-4.73-.01-7.81-1.55-7.71-5.22h4.99c-.12,1.16,1.06,1.94,2.82,1.94,1.66-.01,2.68-.71,2.57-1.65-.13-1.06-2.17-1.52-5.09-2.14-3.3-.71-5.16-2.14-5.16-4.76,0-3.08,3.02-4.61,7.59-4.57,4.24,0,7.59,1.58,7.49,4.99h-4.99c.03-1.13-.91-1.79-2.4-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.51,16.68h4.37v4.04h-4.37v5.74c0,1.48.52,2.17,1.68,2.17h2.69v3.96s-5.05,0-5.05,0c-3.04,0-4.48-1.79-4.48-4.79v-7.09h-2.6v-4.04h1.49c.8,0,.96-.43,1.11-1.22l.32-2.44h4.85v3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.12,28.27c.45.46,1.1.71,1.95.71,1.79,0,3.02-1.42,3.02-3.31v-8.98h5.18v15.91h-5.18v-2.21c-.82,1.58-2.49,2.47-4.61,2.47s-3.57-.54-4.6-1.55c-1.16-1.08-1.71-2.76-1.71-4.95v-9.68h5.18v9.16c0,1.1.25,1.91.77,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.77,32.6v-11.88h-2.33v-4.04h2.33v-2.24c0-1.95,1.42-3.27,3.92-3.27h5.29v3.49h-3.21c-.91,0-1.27.48-1.27,1.16v.87h11.34v15.91h-5.16v-11.88h-6.18v11.88h-4.73Zm13.5-22.8c1.82.01,3.02,1.16,3.02,2.56s-1.2,2.57-3.02,2.57-3.04-1.16-3.04-2.57,1.2-2.56,3.04-2.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m221.59,244.04c-1.42-.12-2.76.64-3.37,1.93,0,0,.11-6.82-4.18-7.97-4.29-1.16-7.89,4.86-7.89,4.86,0,0-.71-.9-1.89-1.75v-97.27h3.68v-5.84h-3.68V46.89h3.68v-5.84h-3.68V5.84h3.68V0H0v5.84h3.68v35.2H0v5.84h3.68v91.1H0v5.84h3.68v99.6H0v5.84h3.68s200.58.01,200.58.01h0s1.9-.01,1.9-.01h18.87s-1.14-4.88-3.44-5.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m189.02,33.47l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m173.94,50.25c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStufiGesloten);
export default __webpack_public_path__ + "static/media/stufi-gesloten.e34f0d4163c01ab343f112f65d765a8d.svg";
export { ForwardRef as ReactComponent };